import React, {Component} from 'react'
import {AppContext} from '@lightspeed-invoicing/core-client/frontend'

import NumberFormat from 'react-number-format';
import GlobalHelper from '../common/GlobalHelper.jsx'

class FormattedInputField extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            locale: 'en',
            placeholder: '',
            value:'',
            valueType:'money',        /* money, decimal*/
            onValueChange: () => {},
            allowNegative: this.props.allowNegative,
        }


        this.decimalSeparator = this.decimalSeparator.bind(this)
        this.thousandSeparator = this.thousandSeparator.bind(this)
        this.formatNumberValue = this.formatNumberValue.bind(this)
        this.isNumericString = this.isNumericString.bind(this)
        this.propManagement = this.propManagement.bind(this)

    }

    componentDidMount() {
        this.setState({locale : AppContext.getLocale().getLanguage()})

        this.propManagement(this.props)
    }

    propManagement(nextProps) {
        /* the goal here is to consume the props so as to send only what's relevant for the input child and avoid warnings about invalid props */
        const childrenProps = Object.assign({}, nextProps);
        delete childrenProps.placeholder;
        delete childrenProps.value;
        delete childrenProps.valueType;
        delete childrenProps.onValueChange;

        let newValue = nextProps.value ? nextProps.value : ''
        this.setState({
            placeholder: nextProps.placeholder,
            value: newValue,
            valueType: nextProps.valueType,
            onValueChange: nextProps.onValueChange,
            childrenProps: childrenProps
        })
    }
    componentWillReceiveProps(nextProps) {
        this.propManagement(nextProps)
    }


    decimalSeparator() {
        return GlobalHelper.decimalSeparator(this.state.locale)
    }

    thousandSeparator() {
        return GlobalHelper.thousandSeparator(this.state.locale)
    }

    formatNumberValue() {
        return GlobalHelper.applyLocaleDecimal(this.state.value,this.state.locale)
    }

    /* If value is passed as string representation of numbers (unformatted) the numericString prop of the NumberFormat component should be passed as true */
    isNumericString() {
        return true
    }

    render() {
        return (
            <NumberFormat {...this.state.childrenProps}
                          placeholder={this.state.placeholder}
                          thousandSeparator={this.thousandSeparator()}
                          decimalSeparator={this.decimalSeparator()}

                          value={this.formatNumberValue()}
                          isNumericString={this.isNumericString()}

                          allowNegative={this.state.allowNegative}  
                          onValueChange={(values) => {
                              const {formattedValue, value} = values;
                              this.setState({value: value})
                              this.state.onValueChange(value)
                          }}/>
        )
    }
}

export default FormattedInputField


// WEBPACK FOOTER //
// ./src/sharedComponents/formattedInputField.component.jsx